import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'custom-loader',
  standalone: false,
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.scss'],
})
export class CustomLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
